"use strict";
exports.__esModule = true;
var React = require("react");
var GoogleMapContext_1 = require("../context/GoogleMapContext");
var operation_1 = require("../googlemap/operation");
var googleMapMarker = function (props) {
    var _a = React.useContext(GoogleMapContext_1.GoogleMapContext), map = _a.map, bound = _a.bound, setBound = _a.setBound, zoom = _a.zoom;
    var _b = React.useState(null), mapObject = _b[0], setMapObject = _b[1];
    var mapObjectRef = React.useRef(null);
    var createMarker = function () {
        if (typeof google === 'undefined')
            return;
        var gLatLng = new google.maps.LatLng({
            lat: props.center.lat,
            lng: props.center.lng
        });
        var pin = new FaMarker(map, gLatLng, props.type, '', props.active);
        google.maps.event.addDomListener(pin, 'click', function () {
            if (props.onClick)
                props.onClick();
        });
        setMapObject(pin);
        operation_1.mapAddObject(map, pin);
        mapObjectRef.current = pin;
        return pin;
    };
    React.useEffect(function () {
        return function () {
            // umount mapObject using ref
            if (mapObjectRef.current)
                operation_1.mapRemoveMarker(mapObjectRef.current);
        };
    }, []);
    React.useEffect(function () {
        if (bound) {
            if (zoom === -1) {
                bound.extend(props.center);
                setBound(bound);
                map.fitBounds(bound);
            }
            if (zoom === -2) {
                var referenceCenter = map.getCenter();
                var markerCenter = props.center;
                var opposite = {
                    lat: referenceCenter.lat() - (markerCenter.lat - referenceCenter.lat()),
                    lng: referenceCenter.lng() - (markerCenter.lng - referenceCenter.lng())
                };
                bound.extend(props.center);
                bound.extend(opposite);
                setBound(bound);
                map.fitBounds(bound);
            }
        }
    }, [zoom]);
    var renderContent = function () {
        if (!mapObject)
            createMarker();
        return null;
    };
    return map ? renderContent() : null;
};
exports.GoogleMapMarker = googleMapMarker;
